<template lang="html">
  <div>
    <form>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="username"
              v-validate="'required'"
              :error-messages="errors.collect('username')"
              data-vv-name="username"
              label="Username*"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              ref="password"
              v-model="password"
              v-validate="'required'"
              :error-messages="errors.collect('password')"
              data-vv-name="password"
              label="Password*"
              type="password"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="confirmPassword"
              v-validate="'required|confirmed:password'"
              :error-messages="errors.collect('confirmPassword')"
              data-vv-name="confirmPassword"
              data-vv-as="password"
              label="Confirm Password*"
              type="password"
            />
          </v-col>
          <!-- <v-col>
            <v-checkbox
              v-model="mobileAccess"
            >
              <template v-slot:label>
                <div>
                  Approval Mobile Access
                </div>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="monitoringAccess"
            >
              <template v-slot:label>
                <div>
                  Approval Monitoring Access
                </div>
              </template>
            </v-checkbox>
          </v-col> -->
        </v-row>
      </v-container>
    </form>
    
    <v-card-actions>
      <v-spacer />
      <v-btn
        :loading="progressing"
        color="success"          
        @click="submitForm"
      >
        Create User
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      personId: {
        type: String,
        default: '',
      },
      personName: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        progressing: false,
        password: null,
        confirmPassword: null,
        username: null,
        mobileAccess: false,
        monitoringAccess: false,
      }
    },
    methods: {
      setProgressing (value = false) {
        this.progressing = value
      },
      validateForm () {
        return this.$validator.validateAll()
      },
      prepareFormData () {
        return {
          person_uid: this.personId,
          name: this.personName,
          username: this.username,
          password: this.password,
          is_mobile_allowed: this.mobileAccess === true ? 1 : 0,
          is_monitoring_allowed: this.monitoringAccess === true ? 1 : 0,
        }
      },
      submitForm () {
        this.validateForm().then((result) => {
          if (result) {          
            this.setProgressing(true)

            this.$api.users().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                               
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          } else {
            this.$scrollToFirstErrorInput()
          }
        })  
      },
    },
  }
</script>
